import { DatePicker } from "@/components/ui/date-picker";

interface FinancingFiltersProps {
  selectedDate: Date | undefined;
  setSelectedDate: (date: Date | undefined) => void;
}

export const FinancingFilters = ({
  selectedDate,
  setSelectedDate,
}: FinancingFiltersProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div className="flex-1">
        <label className="block text-sm font-medium mb-2">
          Filtrer par date
        </label>
        <DatePicker
          selected={selectedDate}
          onSelect={setSelectedDate}
          placeholder="Sélectionner une date"
        />
      </div>
    </div>
  );
};